import { render, staticRenderFns } from "./attributes-ranking.component.vue?vue&type=template&id=320afeaa&scoped=true"
import script from "./attributes-ranking.component.vue?vue&type=script&lang=ts"
export * from "./attributes-ranking.component.vue?vue&type=script&lang=ts"
import style0 from "./attributes-ranking.component.vue?vue&type=style&index=0&id=320afeaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320afeaa",
  null
  
)

export default component.exports